const DITypes = {
  JsonRpcDispatcher: Symbol('CfrInternalJsonRpcDispatcher'),
  DispatcherFactory: Symbol('CfrInternalDispatcherFactory'),
  AdapterFactory: Symbol('CfrInternalAdapterFactory'),
};

export default DITypes;
